// @scripts
import { AxiosError } from 'axios';
import { ISchedule, ISession } from '../utils/types';
import { config } from '../core/config';
import BaseService from './base-service';

class TestingService extends BaseService {
  async getSchedule(siteId: number): Promise<ISchedule[]> {
    return this.get(['schedule', siteId]);
  }

  async getScheduleSessions(siteId: number): Promise<ISession[]> {
    return this.get(['scheduleSessions', siteId]);
  }

  async tryGetCurrentSession(siteId: number): Promise<ISession | undefined> {
    try {
      return await this.get(['currentSession', siteId]);
    } catch (ex) {
      if (ex instanceof AxiosError && ex.response?.status === 404) {
        return undefined;
      }
      if (ex instanceof AxiosError && ex.response?.status === 500) {
        return undefined; // don't fail when the server breaks due to unexpected conditions
      }
      throw ex;
    }
  }

  async pauseSession(siteId: number, sessionId: number): Promise<ISession> {
    return this.put(['pauseSession', siteId, sessionId]);
  }

  async resumeSession(siteId: number, sessionId: number): Promise<ISession> {
    return this.put(['resumeSession', siteId, sessionId]);
  }
}

export default new TestingService(config.services.testing);
